import PropTypes from 'prop-types';
export default {
  id: PropTypes.number.isRequired,
  url: PropTypes.string,
  firstImage: PropTypes.string,
  listingBadges: PropTypes.shape({
    new: PropTypes.bool,
    sold: PropTypes.bool,
    rented: PropTypes.bool,
    underApplication: PropTypes.bool,
    underOffer: PropTypes.bool,
    priceReduced: PropTypes.bool,
    fullyFurnished: PropTypes.bool,
    overFiftyFiveEnabled: PropTypes.bool,
    overSixtyEnabled: PropTypes.bool,
    propertyOfTheWeek: PropTypes.bool,
    featuredProperty: PropTypes.bool,
    development: PropTypes.bool
  }),
  nextInspection: PropTypes.shape({
    id: PropTypes.number.isRequired,
    startdate: PropTypes.string.isRequired,
    enddate: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }),
  numPhotos: PropTypes.number,
  hasVideo: PropTypes.bool,
  has3dTour: PropTypes.bool
};